import { c } from "react-compiler-runtime";
import { useContext, createContext } from "react";
const TransportHookContext = createContext(null);
function useGraphiQLPluginContext() {
  const $ = c(8);
  const registry = useContext(TransportHookContext);
  if (registry === null) {
    let t02;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t02 = {};
      $[0] = t02;
    } else {
      t02 = $[0];
    }
    return t02;
  }
  let t0;
  if ($[1] !== registry) {
    t0 = registry.onBeforeSend.bind(registry);
    $[1] = registry;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== registry) {
    t1 = registry.onResponse.bind(registry);
    $[3] = registry;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      transport: {
        onBeforeSend: t0,
        onResponse: t1
      }
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export {
  TransportHookContext,
  useGraphiQLPluginContext
};
//# sourceMappingURL=transport-hooks.context.js.map
